import { render, staticRenderFns } from "./PostInfoMod.vue?vue&type=template&id=3f462a3a"
import script from "./PostInfoMod.vue?vue&type=script&lang=js"
export * from "./PostInfoMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports